import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { m } from "@/i18n/en";
export function ErrorPage() {
  const error = useRouteError();
  const requestId =
    isRouteErrorResponse(error) &&
    typeof error.data === "object" &&
    error.data &&
    "request_id" in error.data
      ? String(error.data.request_id)
      : undefined;
  return (
    <main className="grid min-h-screen place-items-center p-6">
      <section className="max-w-lg">
        <h1 className="text-3xl font-semibold">{m.errors.title}</h1>
        <p className="mt-3 text-secondary">{m.errors.description}</p>
        {requestId && (
          <p className="mt-3 font-mono text-sm">
            {m.errors.requestId}: {requestId}
          </p>
        )}
        <Button className="mt-8" onClick={() => window.location.reload()}>
          {m.retry}
        </Button>
      </section>
    </main>
  );
}
